export enum PMMercadoPRDTPrefStatusEnum {
  PAID = "p",
  WAITING = "w",
  EXPIRED = "e",
  EXCLUDED = "x",
}

export type PMMercadoPRDTPrefStatusTypes = `${PMMercadoPRDTPrefStatusEnum}`;